import React from "react";
import "./style.css";

const workAreasData = [
  {
    id: 1,
    title: "المجال الاجتماعي",
    items: [
      "تنظيم البرامج التثقيفية المناسبة لأفراد المجتمع المحلي حول مفاهيم الحماية الخاصة بالمساواة او العدالة.",
      "تنظيم البرامج التوعوية والتثقيفية الخاصة بنشر الوعي حول حماية الأطفال والنساء.",
      "تنظيم البرامج والخدمات التي توفر الدعم الملائم وتعزز من الوعي لأشخاص ذوي الإعاقات حول مفاهيم الحماية الخاصة بهم.",
      "تنظيم برامج التثقيف ورفع الوعي للمجتمع المحلي وفئاته ومؤسساته المتنوعة حول مفاهيم الحماية المتعلقة بإدماج اشخاص ذوي الإعاقة في جميع نواحي الحياة.",
    ],
  },
  {
    id: 2,
    title: "المجال الصحي",
    items: [
      "تنظيم برامج التأهيل الصحي الطبيعي للمصابين وذوي الأعاقة وللنساء فيما يتعلق بالصحة الإنجابية ورعاية الطفولة.",
      "تنظيم برامج وقائية وتوعية وتثقيف صحي للوصول لنمط حياة صحي أفضل.",
      "تنظيم ودعم برامج تعزيز الصحة النفسية والعقلية بجميع مظاهرها والتركيز على الانحرافات السلوكية ذات الخطورة على الصحة وظواهر الجنوح المتفشية.",
      "تنظيم برامج وخدمات صحية تخصصية لرعاية المسنين.",
    ],
  },
  {
    id: 3,
    title: "مجال التنمية والإسكان",
    subtitle:
      "تساهم في رفع المستوى المعيشي والاقتصادي الاجتماعي للأسر المستهدفة من خلال:",
    items: [
      "تنظيم برامج تمكين مهني للشباب والنساء القادرين على العمل لإكسابهم مهارات حرفية ومهنية.",
      "تنظيم برامج تدريب للشباب والنساء حول تأسيس المشاريع الصغيرة وإدارتها.",
      "تنظيم معارض لمنتجات المشاريع الصغيرة النسائية والجماعية والأخرى ذات طابع الإنتاجي والتصنيعي.",
    ],
  },
];

const WorkAreas = () => {
  return (
    <section id="work-areas" className="work-areas" dir="rtl">
      <div className="work-areas__inner">
        <div className="container">
          <header className="work-areas__header">
            <h2 className="work-areas__heading">مجالات العمل والتخصصات</h2>
          </header>

          <div className="work-areas__blocks">
            {workAreasData.map((area) => (
              <article key={area.id} className="work-areas__block">
                <div className="work-areas__block-content">
                  {area.subtitle && (
                    <p className="work-areas__subtitle">{area.subtitle}</p>
                  )}
                  <ul className="work-areas__list">
                    {area.items.map((item, idx) => (
                      <li key={idx} className="work-areas__item">
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="work-areas__block-side">
                  <h3 className="work-areas__block-title">{area.title}</h3>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WorkAreas;
